import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { Select } from 'components/common/Select';
import { Controller } from 'react-hook-form';
import { filterUnit } from 'components/template/TemplateForm';
import { fetchLanguages } from 'slices/languageSlice';

const RateInputGroup = ({ errors, label, control, subjectIndex, type, time, tierIndex, prefix, filterUnit, tier, index, name, value, setValue, onTierUpdate }) => {

    useEffect(() => {
        setValue(
            `subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_rate`,
            tier[`${type}_${time.toLowerCase()}_rate`] ?? 0
        );
        setValue(
            `subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_rate_time_unit`,
            tier[`${type}_${time.toLowerCase()}_rate_time_unit`] || 'hour'
        );
    }, [subjectIndex, tierIndex, type, time, tier, setValue]);
    return (
        <div className='Inter_rate_row'>
            <h4>{label}</h4>
            <div className='inter_wrapper'>
                {/* Rate Input */}
                <Controller
                    // name={`custom_${prefix}_rate[${index}]`}
                    name={`subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_rate`}
                    control={control}
                    rules={{ required: "Please enter rate" }}
                    render={({ field }) => (
                        <div className='w-100 input-dollar-group'>
                            <span className="dollar-prefix">$</span>
                            <input
                                className="input-in type_inp dollar-padding"
                                type="number"
                                placeholder={`${label} rate`}
                                {...field}
                                onChange={(e) => {
                                    const val = Math.max(0, parseFloat(e.target.value));
                                    field.onChange(val);
                                    onTierUpdate(tierIndex, `${type}_${time.toLowerCase()}_rate`, val);
                                }}
                            />
                            {errors?.[`custom_${prefix}_rate`] && errors[`custom_${prefix}_rate`][index] && (
                                <ErrorMessage text={errors[`custom_${prefix}_rate`][index].message} />
                            )}
                        </div>
                    )}
                />

                {/* Time Unit Select */}
                <Controller
                    // name={`custom_${prefix}_rate_time_unit[${index}]`}
                    name={`subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_rate_time_unit`}
                    control={control}
                    rules={{ required: "Please select one" }}
                    render={({ field }) => (
                        <div className='w-100'>
                            <Select
                                name={field.name}
                                options={filterUnit || []}
                                value={
                                    filterUnit?.find(opt => opt.value === field.value) ||
                                    ""
                                }
                                isClearable={false}
                                disabledSearch
                                onChange={(selectedOption) => {
                                    field.onChange(selectedOption || "hour");
                                    onTierUpdate(tierIndex, `${type}_${time.toLowerCase()}_rate_time_unit`, selectedOption || "hour");
                                }}
                            />

                            {errors?.[`custom_${prefix}_rate_time_unit`] && errors[`custom_${prefix}_rate_time_unit`][index] && (
                                <ErrorMessage text={errors[`custom_${prefix}_rate_time_unit`][index].message} />
                            )}
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

const MinDurationInputGroup = ({ subjectIndex, tierIndex, type, time, errors, label, control, prefix, filterUnit, index, name, value, minsValue, setValue, onTierUpdate }) => {
    useEffect(() => {
        setValue(
            `subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_mins`,
            minsValue !== undefined ? minsValue : 1100
        );
        setValue(
            `subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_mins_time_unit`,
            value || "minute"
        );
    }, [minsValue, value, setValue, subjectIndex, tierIndex, type, time]);

    return (
        <div className='Inter_rate_row'>
            <div className='inter_wrapper mt-0'>
                {/* Minimum Duration Input */}
                <Controller
                    // name={`custom_${prefix}_mins[${index}]`}
                    // name={`subjectCustomTiers.${subjectIndex}.${tierIndex}.${prefix}_mins`}
                    name={`subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_mins`}
                    control={control}
                    rules={{ required: "Please enter minimum duration" }}
                    render={({ field }) => (
                        <div className='w-100'>
                            <input
                                className="input-in type_inp"
                                type="number"
                                placeholder={`${label} min`}
                                {...field}
                                {...field}
                                onChange={(e) => {
                                    const val = Math.max(0, parseFloat(e.target.value));
                                    field.onChange(val);
                                    onTierUpdate(tierIndex, `${type}_${time.toLowerCase()}_mins`, val);
                                }}
                            />
                            {errors?.[`custom_${prefix}_mins`] && errors[`custom_${prefix}_mins`][index] && (
                                <ErrorMessage text={errors[`custom_${prefix}_mins`][index].message} />
                            )}
                        </div>
                    )}
                />

                {/* Time Unit Select */}
                <Controller
                    // name={`custom_${prefix}_mins_time_unit[${index}]`}
                    name={`subjectCustomTiers.${subjectIndex}.${tierIndex}.${type}_${time.toLowerCase()}_mins_time_unit`}
                    control={control}
                    rules={{ required: "Please select one" }}
                    render={({ field }) => (
                        <div className='w-100'>
                            <Select
                                name={field.name}
                                options={filterUnit || []}
                                value={
                                    filterUnit?.find(opt => opt.value === field.value) || ""
                                }
                                isClearable={false}
                                disabledSearch
                                onChange={(selectedOption) => {
                                    field.onChange(selectedOption || "minute");
                                    onTierUpdate(tierIndex, `${type}_${time.toLowerCase()}_mins_time_unit`, selectedOption || "minute");
                                }}
                            />

                            {errors?.[`custom_${prefix}_mins_time_unit`] &&
                                errors[`custom_${prefix}_mins_time_unit`][index] && (
                                    <ErrorMessage text={errors[`custom_${prefix}_mins_time_unit`][index].message} />
                                )}
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

const CustomTiers = ({ control, errors, dispatch, item, setValue, subjectIndex, unregister, watch }) => {
    const [tiers, setTiers] = useState([]);

    const getSelectedLanguages = () => {
        return tiers.flatMap(tier => tier.languages.map(lang => lang.value));
    };

    const addTier = () => {
        setTiers([...tiers, { id: Date.now(), languages: [] }]);
    };

    const removeTier = (id, index) => {
        setTiers(tiers.filter(tier => tier.id !== id));
        watch('custom_language_ids').splice(index, 1);

        watch('custom_opi_normal_rate').splice(index, 1);
        watch('custom_vri_normal_rate').splice(index, 1);
        watch('custom_inperson_normal_rate').splice(index, 1);
        watch('custom_opi_normal_rate_time_unit').splice(index, 1);
        watch('custom_vri_normal_rate_time_unit').splice(index, 1);
        watch('custom_inperson_normal_rate_time_unit').splice(index, 1);
        watch('custom_opi_normal_mins').splice(index, 1);
        watch('custom_vri_normal_mins').splice(index, 1);
        watch('custom_inperson_normal_mins').splice(index, 1);
        watch('custom_opi_normal_mins_time_unit').splice(index, 1);
        watch('custom_vri_normal_mins_time_unit').splice(index, 1);
        watch('custom_inperson_normal_mins_time_unit').splice(index, 1);

        watch('custom_opi_after_rate').splice(index, 1);
        watch('custom_vri_after_rate').splice(index, 1);
        watch('custom_inperson_after_rate').splice(index, 1);
        watch('custom_opi_after_rate_time_unit').splice(index, 1);
        watch('custom_vri_after_rate_time_unit').splice(index, 1);
        watch('custom_inperson_after_rate_time_unit').splice(index, 1);
        watch('custom_opi_after_mins').splice(index, 1);
        watch('custom_vri_after_mins').splice(index, 1);
        watch('custom_inperson_after_mins').splice(index, 1);
        watch('custom_opi_after_mins_time_unit').splice(index, 1);
        watch('custom_vri_after_mins_time_unit').splice(index, 1);
        watch('custom_inperson_after_mins_time_unit').splice(index, 1);
    };

    const handleTierUpdate = (index, key, value) => {
        setTiers(prev => prev.map((t, i) => i === index ? { ...t, [key]: value } : t));
    };

    const loadLanguages = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        const selectedLanguages = getSelectedLanguages();
        return {
            options: result.data
                .map(val => ({ value: val.id, label: val.name }))
                .filter(lang => !selectedLanguages.includes(lang.value)),
            hasMore: page !== result?.last_page,
            additional: { page: page + 1 },
        };
    };
    useEffect(() => {
        if (item?.Custom_tier?.length) {
            const currentSubject = watch(`subjects.${subjectIndex}`);
            // Filter custom tiers that belong to THIS subject
            const filteredTiers = item.Custom_tier.filter(t => t.subject === currentSubject);

            setTiers(filteredTiers.map((tier, index) => {
                const languageIds = tier.custom_tier_languages?.map(lang => lang?.language?.id) || [];

                // Explicitly set values for hook-form to satisfy validation
                setValue(`subjectCustomTiers.${subjectIndex}.${index}.language_ids`, languageIds);
                setValue(`subjectCustomTiers.${subjectIndex}.${index}.subject`, currentSubject);

                return {
                    id: tier.id || Date.now() + index,
                    languages: tier.custom_tier_languages?.map(lang => ({ value: lang?.language?.id, label: lang?.language?.name })) || [],
                    subject: currentSubject,
                    opi_normal_mins: tier.opi_normal_mins ?? 0,
                    vri_normal_mins: tier.vri_normal_mins ?? 0,
                    inperson_normal_mins: tier.inperson_normal_mins ?? 0,
                    opi_after_mins: tier.opi_after_mins ?? 0,
                    vri_after_mins: tier.vri_after_mins ?? 0,
                    inperson_after_mins: tier.inperson_after_mins ?? 0,
                    opi_normal_mins_time_unit: tier.opi_normal_mins_time_unit || 'minute',
                    vri_normal_mins_time_unit: tier.vri_normal_mins_time_unit || 'minute',
                    inperson_normal_mins_time_unit: tier.inperson_normal_mins_time_unit || 'minute',
                    opi_after_mins_time_unit: tier.opi_after_mins_time_unit || 'minute',
                    vri_after_mins_time_unit: tier.vri_after_mins_time_unit || 'minute',
                    inperson_after_mins_time_unit: tier.inperson_after_mins_time_unit || 'minute',

                    // also copy rates if needed
                    opi_normal_rate: tier.opi_normal_rate ?? 0,
                    vri_normal_rate: tier.vri_normal_rate ?? 0,
                    inperson_normal_rate: tier.inperson_normal_rate ?? 0,
                    opi_after_rate: tier.opi_after_rate ?? 0,
                    vri_after_rate: tier.vri_after_rate ?? 0,
                    inperson_after_rate: tier.inperson_after_rate ?? 0,
                    opi_normal_rate_time_unit: tier.opi_normal_rate_time_unit || 'hour',
                    vri_normal_rate_time_unit: tier.vri_normal_rate_time_unit || 'hour',
                    inperson_normal_rate_time_unit: tier.inperson_normal_time_unit || 'hour',
                    opi_after_rate_time_unit: tier.opi_after_rate_time_unit || 'hour',
                    vri_after_rate_time_unit: tier.vri_after_rate_time_unit || 'hour',
                    inperson_after_rate_time_unit: tier.inperson_after_time_unit || 'hour',
                };
            }));
        }
    }, [item?.Custom_tier, subjectIndex, watch(`subjects.${subjectIndex}`)]);



    return (
        <>
            {(tiers).map((tier, index) => (
                <div key={tier.id} className="w-100 p-3">
                    <div className="row-primary">
                        <h2>Select Languages *</h2>
                        <Controller
                            // name={`custom_language_ids[${index}]`}
                            name={`subjectCustomTiers.${subjectIndex}.${index}.language_ids`}
                            control={control}
                            rules={{ required: "Languages must be specified" }}
                            render={({ field }) => (
                                <AsyncPaginate menuPlacement='auto' isMulti styles={selectCustomStyles}
                                    filterOption={
                                        (e) => {
                                            if (getSelectedLanguages().includes(e.value)) {
                                                return false;
                                            }
                                            else {
                                                return true;
                                            }
                                        }
                                    }
                                    value={tier.languages} loadOptions={loadLanguages} isClearable escapeClearsValue
                                    onChange={selected => {
                                        setTiers(tiers.map(t => t.id === tier.id ? { ...t, languages: selected } : t));
                                        field.onChange(selected.map(opt => opt.value));
                                        setValue(`subjectCustomTiers.${subjectIndex}.${index}.subject`, watch(`subjects.${subjectIndex}`));
                                    }}
                                    additional={{ page: 1 }} />
                            )}
                        />
                        {/* {errors?.[`custom_language_ids[${index}]`]?.message &&
                            <ErrorMessage text={errors[`custom_language_ids[${index}]`].message} />
                        } */}
                        {errors?.[`subjectCustomTiers.${subjectIndex}.${index}.language_ids`]?.message &&
                            <ErrorMessage text={errors[`subjectCustomTiers.${index}.${index}.language_ids`].message} />
                        }

                        <IconButton color="error" onClick={() => removeTier(tier.id, index)}><i className="fa-solid fa-trash-can trash_icon"></i></IconButton>
                    </div>
                    {tier.languages.length > 0 && (
                        ["Normal", "After"].map(time => (
                            <div key={time}>
                                <h2 className='text-center my-3 fw-bold fst-italic'>{time} Hour</h2>
                                <div className='rate_container'>
                                    <div className='row-primary align-items-end'>
                                        <h2 className='mb-3 my-0'>Rates *:</h2>
                                        {["opi", "vri", "inperson"].map((type) => (
                                            <RateInputGroup key={type} label={type == 'inperson' ? 'Inperson' : type.toUpperCase()} control={control}
                                                subjectIndex={subjectIndex}
                                                tierIndex={index}
                                                type={type}
                                                time={time}
                                                prefix={`${type}_${time.toLowerCase()}`}
                                                // prefix={`${type}_${time.toLowerCase().replace(' ', '_')}`}
                                                index={index} filterUnit={filterUnit} errors={errors}
                                                // name={`custom_${`${`${type}_${time.toLowerCase().replace(' ', '_')}`}_rate_time_unit`}[${index}]`}
                                                name={`subjectCustomTiers.${subjectIndex}.${index}.${type}_${time.toLowerCase()}_rate_time_unit`}
                                                value={"hour"}
                                                setValue={setValue}
                                                tier={tier}
                                                onTierUpdate={handleTierUpdate}

                                            />
                                        ))}
                                    </div>
                                    <div className='row-primary align-items-end'>
                                        <h2 className='mb-3 my-0'>Minimum *:</h2>
                                        {["opi", "vri", "inperson"].map((type) => (
                                            <MinDurationInputGroup
                                                key={type}
                                                subjectIndex={subjectIndex}
                                                label={type === 'inperson' ? 'Inperson' : type.toUpperCase()}
                                                control={control}
                                                time={time}
                                                type={type}
                                                prefix={`${type}_${time.toLowerCase().replace(' ', '_')}`}
                                                tierIndex={index}
                                                filterUnit={filterUnit}
                                                errors={errors}
                                                // name={`custom_${type}_${time.toLowerCase().replace(' ', '_')}_mins_time_unit[${index}]`}
                                                name={`subjectCustomTiers.${subjectIndex}.${index}.${type}_${time.toLowerCase()}_mins_time_unit`}
                                                // value={"minute"}
                                                value={tier[`${type}_${time.toLowerCase()}_mins_time_unit`] ?? "minute"}
                                                minsValue={tier[`${type}_${time.toLowerCase()}_mins`] ?? 0}
                                                setValue={setValue}
                                                onTierUpdate={handleTierUpdate}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            ))}
            <button type="button" className='main_button' onClick={addTier}>Add Custom Tier</button>
        </>
    );
};

export default CustomTiers;